import { useEffect, useState } from 'react'
import PostContainer from './Posts/PostContainer';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { clearErrors, followUser, getUserDetails, logoutUser } from '../../actions/userAction';
import { clearErrors as clearChatErrors, addNewChat } from '../../actions/chatAction';
import { toast } from 'react-toastify';
import BackdropLoader from '../Layouts/BackdropLoader';
import { metaballsMenu, postsIconFill, postsIconOutline, reelsIcon, savedIconFill, savedIconOutline, settingsIcon, taggedIcon } from './SvgIcons';
import { FOLLOW_USER_RESET, USER_DETAILS_RESET } from '../../constants/userConstants';
import UsersDialog from '../Layouts/UsersDialog';
import { NEW_CHAT_RESET } from '../../constants/chatConstants';
import MetaData from '../Layouts/MetaData';
import NotFound from '../Errors/NotFound';
import { Dialog } from '@mui/material';

const Profile = () => {

    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    const [follow, setFollow] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [followersModal, setFollowersModal] = useState(false);
    const [usersArr, setUsersArr] = useState([]);
    const [savedTab, setSavedTab] = useState(false);
    const [settingsModal, setSettingsModal] = useState(false);

    const { user, error, loading } = useSelector((state) => state.userDetails);
    const { user: loggedInUser } = useSelector((state) => state.user);
    const { error: followError, success, message } = useSelector((state) => state.followUser);
    const { error: chatError, chat } = useSelector((state) => state.newChat);

    const handleFollow = () => {
        // setFollow(!follow); 
        dispatch(followUser(user._id));
    }

    const handleFollowersModal = () => {
        setFollowersModal(true);
        setViewModal(true)
        setUsersArr(user?.followers);
    }

    const handleFollowingModal = () => {
        setViewModal(true)
        setFollowersModal(false);
        setUsersArr(user?.following);
    }

    const closeModal = () => {
        setViewModal(false)
    }

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        dispatch(getUserDetails(params.username));

        if (followError) {
            toast.error(followError);
            dispatch(clearErrors());
        }
        if (success) {
            toast.success(message)
            dispatch({ type: FOLLOW_USER_RESET });
        }

        // return () => {
        //     dispatch({ type: USER_DETAILS_RESET })
        // }

    }, [dispatch, error, params.username, followError, success, message]);

    useEffect(() => {
        // console.log(user?.followers?.some((id) => id === loggedInUser._id))
        setFollow(user?.followers?.some((u) => u._id === loggedInUser._id))
    }, [user]);

    const addToChat = () => {
        dispatch(addNewChat(user._id));
    }

    useEffect(() => {
        if (chatError) {
            toast.error(chatError);
            dispatch(clearChatErrors());
        }
        if (chat) {
            const friendId = chat.users?.find((id) => id !== loggedInUser._id);
            navigate(`/direct/t/${chat._id}/${friendId}`);
            dispatch({ type: NEW_CHAT_RESET });
        }
    }, [dispatch, chatError, chat, navigate]);

    const handleLogout = () => {
        dispatch(logoutUser());
        navigate("/login");
        toast.success("Logout Successfully");
    };

    return (
        <>
            <MetaData title={`${user?.name} (@${user?.username}) • Instagram photos and videos`} />

            {loading && <BackdropLoader />}
            {user ?
                <div className="mt-16 xl:w-2/3 mx-auto pb-16 sm:pb-4">

                    {/* Profile header — stack on mobile, side-by-side on sm+ */}
                    <div className="flex flex-col sm:flex-row w-full sm:py-8 py-4 px-4 sm:px-0">

                        {/* Avatar */}
                        <div className="sm:w-1/3 flex justify-center sm:justify-center mb-4 sm:mb-0">
                            <img draggable="false"
                                className="w-24 h-24 sm:w-36 sm:h-36 lg:w-40 lg:h-40 rounded-full object-cover ring-2 ring-gray-200"
                                src={user.avatar} alt="" />
                        </div>

                        {/* Details */}
                        <div className="flex flex-col gap-3 sm:gap-5 sm:w-2/3 sm:p-1">

                            {/* Username + action buttons row */}
                            <div className="flex items-center gap-3 sm:gap-8 sm:justify-start justify-between">
                                <h2 className="text-lg sm:text-3xl font-thin truncate">{user.username}</h2>
                                {(loggedInUser.username === user.username) ? (
                                    <div className="flex gap-2 sm:gap-3 items-center">
                                        <Link to="/accounts/edit" className="border font-medium hover:bg-gray-50 text-xs sm:text-sm rounded px-2 py-1 whitespace-nowrap">Edit Profile</Link>
                                        <button 
                                            type="button"
                                            onClick={(e) => { e.currentTarget.blur(); setSettingsModal(true); }} 
                                            className="p-1 hover:opacity-80"
                                        >
                                            {settingsIcon}
                                        </button>
                                    </div>
                                ) : (
                                    <div className="flex gap-2 sm:gap-3 items-center">
                                        {follow ? (
                                            <>
                                                <button onClick={addToChat} className="border rounded px-2 sm:px-2.5 py-1 text-xs sm:text-sm font-medium hover:bg-gray-100 whitespace-nowrap">Message</button>
                                                <button onClick={handleFollow} className="font-medium text-xs sm:text-sm bg-red-50 rounded py-1 sm:py-1.5 px-2 sm:px-3 text-red-600 hover:bg-red-100 hover:text-red-700 whitespace-nowrap">Unfollow</button>
                                            </>
                                        ) : (
                                            <button onClick={handleFollow} className="font-medium bg-primary-blue text-xs sm:text-sm text-white hover:shadow rounded px-4 sm:px-6 py-1 sm:py-1.5 whitespace-nowrap">Follow</button>
                                        )}
                                        <span className="hidden sm:block">{metaballsMenu}</span>
                                    </div>
                                )}
                            </div>

                            {/* Stats */}
                            <div className="flex gap-4 sm:gap-0 sm:justify-between items-center sm:max-w-[21.5rem]">
                                <div className="flex flex-col sm:flex-row sm:gap-1 items-center cursor-pointer">
                                    <span className="font-semibold text-sm sm:text-base">{user.posts?.length}</span>
                                    <span className="text-xs sm:text-sm text-gray-500 sm:text-black">posts</span>
                                </div>
                                <div onClick={handleFollowersModal} className="flex flex-col sm:flex-row sm:gap-1 items-center cursor-pointer">
                                    <span className="font-semibold text-sm sm:text-base">{user.followers?.length}</span>
                                    <span className="text-xs sm:text-sm text-gray-500 sm:text-black">followers</span>
                                </div>
                                <div onClick={handleFollowingModal} className="flex flex-col sm:flex-row sm:gap-1 items-center cursor-pointer">
                                    <span className="font-semibold text-sm sm:text-base">{user.following?.length}</span>
                                    <span className="text-xs sm:text-sm text-gray-500 sm:text-black">following</span>
                                </div>
                            </div>

                            {/* Bio */}
                            <div className="max-w-full">
                                <p className="font-medium text-sm sm:text-base">{user.name}</p>
                                <p className="whitespace-pre-line text-sm">{user.bio}</p>
                                {user?.website &&
                                    <a href={user.website} target="_blank" rel="noreferrer" className="text-blue-900 font-medium text-sm">{new URL(user.website).hostname}</a>
                                }
                            </div>
                        </div>

                    </div>

                    {followersModal ?
                        <UsersDialog title="Followers" open={viewModal} onClose={closeModal} usersList={user?.followers} />
                        :
                        <UsersDialog title="Following" open={viewModal} onClose={closeModal} usersList={user?.following} />
                    }

                    <div className="border-t sm:ml-8 sm:mr-14">

                        {/* Tabs — icons only on mobile, icons+text on desktop */}
                        <div className="flex justify-center">
                            <span onClick={() => setSavedTab(false)}
                                className={`${savedTab ? 'text-gray-400' : 'border-t border-black -mt-[1px]'} py-3 px-4 sm:px-6 cursor-pointer flex items-center text-[11px] sm:text-[13px] uppercase gap-1.5 sm:gap-3 tracking-[1px] font-medium`}>
                                <span className="sm:block">{savedTab ? postsIconOutline : postsIconFill}</span>
                                <span className="hidden sm:inline">posts</span>
                            </span>
                            {user._id === loggedInUser._id && (
                                <span onClick={() => setSavedTab(true)}
                                    className={`${savedTab ? 'border-t border-black -mt-[1px]' : 'text-gray-400'} py-3 px-4 sm:px-6 cursor-pointer flex items-center text-[11px] sm:text-[13px] uppercase gap-1.5 sm:gap-3 tracking-[1px] font-medium`}>
                                    <span className="sm:block">{savedTab ? savedIconFill : savedIconOutline}</span>
                                    <span className="hidden sm:inline">saved</span>
                                </span>
                            )}
                            <span className="py-3 px-4 sm:px-6 flex items-center text-gray-400 text-[11px] sm:text-[13px] uppercase gap-1.5 sm:gap-3 tracking-[1px] font-medium">
                                {reelsIcon}
                                <span className="hidden sm:inline">reels</span>
                            </span>
                            <span className="py-3 px-4 sm:px-6 hidden sm:flex items-center text-gray-400 text-[13px] uppercase gap-3 tracking-[1px] font-medium">
                                {taggedIcon} tagged
                            </span>
                        </div>

                        {/* posts grid data */}
                        {savedTab ?
                            <PostContainer posts={user?.saved} id={"saved"} /> :
                            user?.posts?.length > 0 ?
                                <PostContainer posts={user?.posts} id={"posts"} /> :
                                <div className="bg-white mt-2 mb-10 drop-shadow-sm rounded flex sm:flex-row flex-col sm:gap-0 gap-5 sm:p-0 p-4 items-center justify-between">
                                    <img draggable="false" className="w-2/5 rounded-l" src="https://www.instagram.com/static/images/mediaUpsell.jpg/6efc710a1d5a.jpg" alt="" />
                                    <div className="mx-auto flex flex-col items-center">
                                        <h4 className="font-medium text-lg sm:text-xl">Start capturing and sharing your moments.</h4>
                                        <p>Get the app to share your first photo or video.</p>
                                    </div>

                                </div>
                        }

                    </div>

                </div>
                :
                <NotFound />
            }

            <Dialog open={settingsModal} onClose={() => setSettingsModal(false)}>
                <div className="flex flex-col w-72 sm:w-80 bg-white">
                    <button
                        onClick={() => { setSettingsModal(false); navigate("/accounts/password/change"); }}
                        className="py-3.5 text-sm text-black font-semibold border-b hover:bg-gray-50 active:bg-gray-100 transition-colors"
                    >
                        Change Password
                    </button>
                    <button
                        onClick={() => { setSettingsModal(false); handleLogout(); }}
                        className="py-3.5 text-sm text-red-500 font-bold border-b hover:bg-red-50 active:bg-red-100 transition-colors"
                    >
                        Log Out
                    </button>
                    <button
                        onClick={() => setSettingsModal(false)}
                        className="py-3.5 text-sm text-gray-500 hover:bg-gray-50 active:bg-gray-100 transition-colors"
                    >
                        Cancel
                    </button>
                </div>
            </Dialog>
        </>
    )
}

export default Profile
